import { PrimaryButton } from "@shared/buttons";

import { NegativeTrendCheckbox } from "../custom-metric-inputs/negative-trend-checkbox";
import { useCurrentlyUpdatingMetric } from "../hooks/use-currently-updating-metric";

export const NoMetricsStateInput = () => {
  const { createCurrentlyUpdatingMetric } = useCurrentlyUpdatingMetric();

  return (
    <div className="[grid-area:formula-input]">
      <div className="border border-gray-2 rounded-md h-[304px]">
        <div className="h-full w-full flex-center">
          <div className="flex flex-col items-center">
            <div className="text-center mx-6">
              Need to track a unique KPI? Use your existing Northbeam data to
              create a custom metric.
            </div>
            <PrimaryButton
              className="mt-4"
              onClick={() => createCurrentlyUpdatingMetric()}
            >
              CREATE NEW METRIC
            </PrimaryButton>
          </div>
        </div>
      </div>
      <NegativeTrendCheckbox isDisabled />
    </div>
  );
};
